import React, { useEffect, useRef, useState } from 'react';

import {
  Button,
  Divider,
  FormControl,
  Modal,
  TextField,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import Autocomplete from '@material-ui/lab/Autocomplete';
import stylesMaterial from './stylesMaterial';
import { Container, Header } from './styles';
import { useToast } from '../../../../../hooks/toast';
import ComponentToPrintEdited from '../../../ComponentToPrintEdited';
import { useReactToPrint } from 'react-to-print';
import { IOrderItem } from '../../../../../interfaces/IOrderItem';
import moment from 'moment';
import { IOrder } from '../../../../../interfaces/IOrder';
import { IDeliveryAddress } from '../../../../../interfaces/IDeliveryAddress';
import { IPaymentMethod } from '../../../../../interfaces/IPaymentMethod';

interface PrintEditedOrderProps {
  open: boolean;
  handleClose: () => void;
  items: IOrderItem[];
  order: (Partial<IOrder> & {
    deliveryAddress?: Partial<IDeliveryAddress>;
    orderPayment: Partial<IPaymentMethod> & { companyPaymentMethod?: any }; // alterar
    items: Partial<IOrderItem>[];
  });
}

export function PrintEditedOrder({
  open,
  handleClose,
  items,
  order
}: PrintEditedOrderProps) {
  const classes = stylesMaterial();
  const inputEl = useRef(null);

  const { addToast } = useToast();

  const [hourOptions, setHourOptions] = useState<string[]>([])
  const [selectedHour, setSelectedHour] = useState<string | null>(null);

  useEffect(() => {
    const createdAtArr = items.map((item) => item.createdAt);
    const hoursOptionsTemp = createdAtArr.filter(
      (item, index) => createdAtArr.findIndex(
        (newItem) => item.localeCompare(newItem) === 0
      ) === index
    );
    setHourOptions(hoursOptionsTemp);
    setSelectedHour(hoursOptionsTemp.sort((a,b) => {
      return (new Date(b)).getTime() - (new Date(a)).getTime();
    })[0]);
  }, []);

  const handlePrint = useReactToPrint({
    content: () => inputEl.current,
  });

  function handlePrintEdited() {
    if(handlePrint) {
      handlePrint();
      addToast({
        title: 'Gerando impressão...',
        type: 'info',
      });
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="print-edited-order-modal"
      aria-describedby="print-edited-order"
      className={classes.modal}
    >
      <Container>
        <Header>
          <Typography className={classes.title}>
            Produção
          </Typography>
        </Header>
        <Divider />
        <FormControl className={classes.formControl}>
          <Autocomplete
            id="combo-box-hour"
            options={hourOptions}
            getOptionLabel={(option) => moment(new Date(option)).format('LLLL:ss')}
            value={selectedHour}
            onChange={(event: any, newValue: string | null) => {
              if (newValue !== null) {
                setSelectedHour(newValue);
              }
            }}
            getOptionSelected={(option, value) => option.localeCompare(value) === 0}
            renderInput={(params) => (
              <TextField
                {...params}
                name="hour"
                type="hour"
                label="Horário da edição"
                variant="outlined"
              />
            )}
            noOptionsText={'Selecione uma razão'}
            loadingText='Carregando...'

          />

          <Button
            disabled={!selectedHour}
            onClick={handlePrintEdited}
            className={classes.button}
          >
            Imprimir
          </Button>

          <Button
            onClick={handleClose}
            className={classes.closeButton}
          >
            Fechar
          </Button>

          <div style={{ display: 'none' }}>
            <ComponentToPrintEdited 
              ref={inputEl} 
              pedido={order}
              selectedHour={selectedHour || ''}
            />
          </div>
        </FormControl>
      </Container>
    </Modal>
  );
}